import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ReportView from "@/components/ReportView";
import { getSweep } from "@/lib/api";

export default function ReportPage() {
  const { id } = useParams();
  const [state, setState] = useState({ status: "loading", report: null, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await getSweep(id);
        if (!cancelled) setState({ status: "ready", report: r, error: null });
      } catch (e) {
        if (!cancelled) setState({ status: "error", report: null, error: e });
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  return (
    <>
      <Nav />
      <div className="pt-32 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="border-b border-[#ddd8ce] py-4 flex items-center justify-between">
          <Link to="/" className="tick hover:text-[#171717] flex items-center gap-2 transition-colors" data-testid="report-back-link">
            <ArrowLeft size={12} /> Back to home
          </Link>
          {/* Not "archived" - a sweep now lands here the moment it finishes,
              seconds old. This page serves a fresh briefing and one reopened
              from My Account, so it names the thing rather than its age. */}
          <span className="tick">Margin risk sweep</span>
        </div>
        <div className="py-10">
          {state.status === "loading" && (
            <div className="flex items-center gap-3 text-[#404040] font-mono-tech text-[13px]" data-testid="report-loading">
              <Loader2 size={16} className="animate-spin text-[#e88a51]" /> Retrieving briefing…
            </div>
          )}
          {state.status === "error" && (
            <div className="card-cream p-8" data-testid="report-error">
              <div className="tick mb-3">404 · Briefing not found</div>
              <p className="font-serif-display text-2xl text-[#171717]">
                We couldn't retrieve that report from the archive.
              </p>
              <p className="font-mono-tech text-[12px] text-[#404040] mt-3">
                The id may be malformed or the record was purged. Run a fresh sweep from the homepage.
              </p>
            </div>
          )}
          {state.status === "ready" && state.report && <ReportView report={state.report} />}
        </div>
      </div>
      <Footer />
    </>
  );
}
